/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2495
 */

var r = require(/* 2496 */"./2496/index")
var i = require(/* 995 */"../../../995/index")
var o = require(/* 1177 */"../../1177/index")
module.exports = function () {
  this.size = 0
  this.__data__ = {
    hash: new r(),
    map: new (o || i)(),
    string: new r()
  }
}
